import { Component, Input, OnInit } from '@angular/core';
import { IDashboardMumPayload, IFaq } from 'src/app/models/dashboard.models';

@Component({
  selector: 'app-tips-for-pregnancy',
  templateUrl: './tips-for-pregnancy.component.html',
  styleUrls: ['./tips-for-pregnancy.component.scss']
})
export class TipsForPregnancyComponent implements OnInit {

  @Input() dashboard: IDashboardMumPayload;
  faqs: Array<IFaq> = [];

  constructor() { }

  ngOnInit(): void {
    this.faqs = this.dashboard.faqs;
  }

}
